module.exports = __webpack_public_path__ + "media/images/img-travel-12-d5207a0e.jpg";